import templateSetData from "./artworkTemplates.json";

export * from "./type";
export * from "./constants";

export default templateSetData;
